import DotSeparator from './DotSeparator';

export default DotSeparator;
